'use client'
import { useEffect, useState } from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import api from '@/shared/api'
import { ENDPOINTS } from '@/shared/constants'
import { HelpCategory, HelpResource } from '@/models/helpCenter'

export default function OfficialApiHelp({
  compact = false,
}: {
  compact?: boolean
}) {
  const [category, setCategory] = useState<number>()
  const [materials, setMaterials] = useState<HelpResource[]>([])
  useEffect(() => {
    const controller = new AbortController()
    void (async () => {
      const { data } = await api.get<HelpCategory[]>(
        ENDPOINTS.HELP_CENTER.CATEGORIES,
        { signal: controller.signal }
      )
      const official = data.find((item) =>
        item.name
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .includes('api oficial')
      )
      if (!official) return
      setCategory(official.id)
      if (compact) return
      const resources = await api.get<HelpResource[]>(
        ENDPOINTS.HELP_CENTER.RESOURCES,
        { params: { categoryId: official.id }, signal: controller.signal }
      )
      setMaterials(
        resources.data
          .filter((item) => item.status === 'published')
          .sort((a, b) => a.position - b.position || a.id - b.id)
          .slice(0, 3)
      )
    })().catch(() => undefined)
    return () => controller.abort()
  }, [compact])
  const href = category ? `/help-center?categoryId=${category}` : '/help-center'
  if (compact)
    return (
      <Box sx={{ pb: 1.5, textAlign: 'center' }}>
        <Button href={href} target="_blank" rel="noopener noreferrer">
          Dúvidas? Veja o guia de ativação
        </Button>
      </Box>
    )
  return (
    <Stack spacing={0.5} alignItems="flex-start">
      <Typography variant="bodyEmphasis">
        Saiba mais sobre a API oficial
      </Typography>
      {materials.map((item) => (
        <Button
          key={item.id}
          href={
            item.type === 'pdf'
              ? `${href}&resourceId=${item.id}`
              : item.url || href
          }
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            textAlign: 'left',
            justifyContent: 'flex-start',
            whiteSpace: 'normal',
          }}
        >
          {item.title}
        </Button>
      ))}
      <Button href={href} target="_blank" rel="noopener noreferrer">
        {category ? 'Ver todos os materiais' : 'Acessar Central de Ajuda'}
      </Button>
    </Stack>
  )
}
